import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMoon: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="moon, dark-mode, night"><path d="M21.2481 11.8112C20.1889 12.5601 18.8958 13.0001 17.5 13.0001C13.9101 13.0001 11 10.0899 11 6.50006C11 5.10422 11.44 3.81114 12.1888 2.75195C12.126 2.75069 12.0631 2.75006 12 2.75006C6.89137 2.75006 2.75 6.89143 2.75 12.0001C2.75 17.1087 6.89137 21.2501 12 21.2501C17.1086 21.2501 21.25 17.1087 21.25 12.0001C21.25 11.937 21.2494 11.874 21.2481 11.8112Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconMoon;
